export const promiseOnce = (
  promisedFn: () => Promise<void>,
): (() => Promise<void>) => {
  let promise: Promise<void> | null = null;
  return () => {
    if (!promise) {
      promise = promisedFn();
    }
    return promise;
  };
};
